module.exports = __webpack_public_path__ + "static/media/coffee-unstoppable-force.586336c4.jpg";